import React from 'react';

export default function Footer({ lang }) {
  const year = new Date().getFullYear();

  const links = {
    en: [
      { label: 'Terms (AGB)', href: '/agb.html' },
      { label: 'Subscription', href: '/abo.html' },
      { label: 'Imprint', href: '/impressum.html' },
      { label: 'Contact', href: '/kontakt.html' },
    ],
    de: [
      { label: 'AGB', href: '/agb.html' },
      { label: 'Abo-Verwaltung', href: '/abo.html' },
      { label: 'Impressum', href: '/impressum.html' },
      { label: 'Kontakt', href: '/kontakt.html' },
    ],
  };

  return (
    <footer className="bg-white border-t border-slate-100 py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo + blurb */}
          <div className="flex flex-col items-center sm:items-start gap-1">
            <a href="/" className="flex items-center gap-0.5 select-none">
              <span className="text-xl font-black tracking-tight text-emerald-600">FitX</span>
              <span className="text-xl font-black tracking-tight text-slate-900">celerate</span>
              <span className="ml-1.5 text-sm">🇨🇭</span>
            </a>
            <p className="text-xs text-slate-400">
              {lang === 'de'
                ? 'FitXcelerate — ganzheitliches Wohlbefinden für die Schweiz.'
                : 'FitXcelerate — holistic wellbeing for Switzerland.'}
            </p>
          </div>

          {/* Links */}
          <nav className="flex items-center gap-6 flex-wrap justify-center">
            {links[lang].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-slate-400 hover:text-emerald-600 transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Copyright */}
          <p className="text-sm text-slate-400 whitespace-nowrap">
            © {year} FitXcelerate
          </p>
        </div>
      </div>
    </footer>
  );
}
